/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const submitModifyOrder = (jwtToken, payload, params, headers) => {
    const wcEnv = {
        rootUri: '/retention',
    };
    const resourcePage = '/selfservice/mmo/orders';

    return restClient.putFacade(wcEnv, resourcePage, jwtToken, payload, params, headers, false)
        .then((response) => response);
};

export default submitModifyOrder;
